import GroupMenu from './GroupMenu';
import GroupMenuContainer from './GroupMenu.container';

export default GroupMenuContainer(GroupMenu);
